export const passwordRegexRule = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*[А-Яа-я]).*$/;
